import { FormattedMessage } from 'react-intl'
import { UseFormReturn } from 'react-hook-form'
import { Box, Chip, useTheme } from '@mui/material'
import { Alert, Avatar, Button, Typography } from '@carto/meridian-ds/components'
import { getCartoColorStylePropsForItem } from '@carto/meridian-ds/theme'
import { ArrowForward } from '@mui/icons-material'

interface SnowflakeConnectionOAuthUserProps {
  form: Omit<UseFormReturn, 'handleSubmit' | 'formState'>
  snowflakeUser: string
  isInvalidOauth: boolean
  onRequestNewOauth: () => void
}

function SnowflakeConnectionOAuthUser({
  form,
  isInvalidOauth,
  onRequestNewOauth,
  snowflakeUser
}: SnowflakeConnectionOAuthUserProps) {
  const theme = useTheme()
  const { getValues, setValue } = form

  return (
    <>
      <Typography sx={{ mt: 2, display: 'block' }} variant="caption">
        <FormattedMessage id="connections.create.snowflake.form.connectedSnowflakeUser" />
      </Typography>
      {isInvalidOauth ? (
        <>
          <Button
            variant="outlined"
            endIcon={<ArrowForward />}
            onClick={() => {
              // Force dirty state to enable submit button
              setValue('client_email', getValues('client_email'), { shouldDirty: true })
              onRequestNewOauth()
            }}
          >
            <FormattedMessage id="connections.create.snowflake.connectUsingOAuth" />
          </Button>
          <Box sx={{ mt: 2 }}>
            <Alert severity="error">
              <FormattedMessage id="connections.create.snowflake.oauth.error" />
            </Alert>
          </Box>
        </>
      ) : (
        <>
          <Chip
            label={snowflakeUser}
            variant="outlined"
            color="default"
            avatar={
              <Avatar
                style={{
                  ...getCartoColorStylePropsForItem(theme, 2)
                }}
              >
                {snowflakeUser.toLocaleUpperCase().slice(0, 1)}
              </Avatar>
            }
          />
        </>
      )}
    </>
  )
}

export default SnowflakeConnectionOAuthUser
